import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=f653f936&scoped=true&"
import script from "./LogoutView.vue?vue&type=script&lang=js&"
export * from "./LogoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f653f936",
  null
  
)

export default component.exports